function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconParking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillopacity: 1,
      stroke: "none",
      strokeWidth: 1.95019042
    },
    d: "M7.532 5.5v13h2.743v-4.624h1.177c1.605 0 2.84-.371 3.71-1.112.87-.743 1.306-1.813 1.306-3.211 0-1.346-.411-2.357-1.227-3.036-.819-.679-2.01-1.017-3.58-1.017Zm2.743 2.255h1.249c1.375 0 2.175.502 2.175 1.897 0 1.453-1.07 1.965-2.522 1.965h-.902z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconParking);
export default __webpack_public_path__ + "static/media/icon_parking.9f02914904b970617d1cb549a9508849.svg";
export { ForwardRef as ReactComponent };